"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Schema = void 0;
/**
 * Transliteration schema base features.
 */
var mapping_1 = require("./mapping");
/** Transliteration schema. Defines the way to translate individual letters. */
var Schema = /** @class */ (function () {
    function Schema(name, mapping, prevMapping, nextMapping, endingMapping, samples) {
        this.name = name;
        this.map = new mapping_1.LetterMapping(mapping);
        this.prevMap = new mapping_1.PrevMapping(prevMapping || new Map());
        this.nextMap = new mapping_1.NextMapping(nextMapping || new Map());
        this.endingMap = new mapping_1.EndingMapping(endingMapping || new Map());
        this.samples = samples || [];
    }
    /**
     * Translate `curr` letter according to schema mappings.
     * `prev` and `next` are taken into consideration according to corresponding mappings.
     * @param prev previous letter
     * @param curr current letter
     * @param next next letter
     */
    Schema.prototype.translateLetter = function (prev, curr, next) {
        var letter = this.prevMap.get(prev + curr);
        if (letter === undefined) {
            letter = this.nextMap.get(curr + next);
        }
        if (letter === undefined) {
            letter = this.map.get(curr, curr);
        }
        return letter;
    };
    /** Translate word ending according to schema mapping. */
    Schema.prototype.translateEnding = function (ending) {
        return this.endingMap.get(ending);
    };
    Schema.load = function (definition) {
        return new Schema(definition.name, new Map(Object.entries(definition.mapping)), new Map(Object.entries(definition.prev_mapping || {})), new Map(Object.entries(definition.next_mapping || {})), new Map(Object.entries(definition.ending_mapping || {})), definition.samples);
    };
    return Schema;
}());
exports.Schema = Schema;
